"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FilterService_1 = __importDefault(require("./FilterService"));
var Filter = (function () {
    function Filter(createUi, templateState, make) {
        var _this = this;
        var filterService;
        this.refresh = function (newTemplateState) {
            filterService = make(FilterService_1.default, {
                templateState: newTemplateState,
            });
            _this._ui.dropdown = filterService.getDropdown();
            _this._ui.search = filterService.getSearch();
            _this._ui.useCases = filterService.getUseCases();
            _this._ui.showDropdown = filterService.shouldShowDropdown();
            _this._ui.showUseCases = filterService.shouldShowUseCases();
        };
        this._ui = createUi(require("./Filter.html"), {});
        this.refresh(templateState);
    }
    Object.defineProperty(Filter.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return Filter;
}());
exports.default = Filter;
